"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Root_exports = {};
__export(Root_exports, {
  Root: () => Root
});
module.exports = __toCommonJS(Root_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_theme = require("./fork/theme");
var import_color_scheme = require("@vxrn/color-scheme");
var import_react = require("react");
var import_constants = require("./constants");
var import_screensFeatureFlags = require("./screensFeatureFlags");
var import_SpaShellContext = require("./router/SpaShellContext");
var import_NavigationContainer = require("./fork/NavigationContainer");
var import_getURL = require("./getURL");
var import_FlagsContext = require("./router/FlagsContext");
var import_linkingConfig = require("./router/linkingConfig");
var import_router = require("./router/router");
var import_serverLocationContext = require("./router/serverLocationContext");
var import_useInitializeOneRouter = require("./router/useInitializeOneRouter");
var import_useViteRoutes = require("./router/useViteRoutes");
var import_evictOldest = require("./utils/evictOldest");
var import_useServerHeadInsertion = require("./useServerHeadInsertion");
var import_PreloadLinks = require("./views/PreloadLinks");
var import_RootErrorBoundary = require("./views/RootErrorBoundary");
var import_ScrollBehavior = require("./views/ScrollBehavior");
var ssrLocationCache = /* @__PURE__ */ new Map();
function getCachedSSRLocation(path) {
  var url = ssrLocationCache.get(path);
  if (url) return url;
  url = new URL(path, (0, import_getURL.getURL)());
  (0, import_evictOldest.evictOldest)(ssrLocationCache, 5e3, 1e3);
  ssrLocationCache.set(path, url);
  return url;
}
var ServerAsyncLocalIDContext = /* @__PURE__ */ (0, import_react.createContext)(null);
globalThis["__vxrnGetContextFromReactContext"] = function() {
  return (0, import_react.useContext)(ServerAsyncLocalIDContext);
};
function Root(props) {
  var _globalThis___vxrnrequestAsyncLocalStore;
  if (import_constants.isNative) {
    (0, import_screensFeatureFlags.initScreensFeatureFlags)();
  }
  var { path, routes, routeOptions, isClient, navigationContainerProps, onRenderId, linking } = props;
  var context = (0, import_useViteRoutes.useViteRoutes)(routes, props.routerRoot, routeOptions, globalThis["__vxrnVersion"]);
  var location = typeof window !== "undefined" && window.location ? new URL(path || window.location.href || "/", window.location.href) : getCachedSSRLocation(path || "/");
  var store = (0, import_useInitializeOneRouter.useInitializeOneRouter)(context, location, linking);
  var userScheme = (0, import_color_scheme.useUserScheme)();
  var Component = store.rootComponent;
  if (!Component) {
    throw new Error(`No root component found`);
  }
  var id = (0, import_react.useId)();
  onRenderId === null || onRenderId === void 0 ? void 0 : onRenderId(id);
  var value = process.env.VERCEL ? globalThis["__oneGlobalContextId"] : ((_globalThis___vxrnrequestAsyncLocalStore = globalThis["__vxrnrequestAsyncLocalStore"]) === null || _globalThis___vxrnrequestAsyncLocalStore === void 0 ? void 0 : _globalThis___vxrnrequestAsyncLocalStore.getStore()) || null;
  var deferredPreloads = props.deferredPreloads;
  var contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ServerAsyncLocalIDContext.Provider, {
    value,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_useServerHeadInsertion.ServerRenderID.Provider, {
      value: id,
      children: [
        typeof window === "undefined" && (deferredPreloads === null || deferredPreloads === void 0 ? void 0 : deferredPreloads.map(function(src) {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("link", {
            rel: "modulepreload",
            fetchPriority: "low",
            href: src
          }, src);
        })),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_NavigationContainer.NavigationContainer, {
          ref: store.navigationRef,
          initialState: store.initialState,
          linking: (0, import_linkingConfig.getResolvedLinking)(),
          onUnhandledAction,
          onStateChange: import_router.handleNavigationContainerStateChange,
          theme: userScheme.value === "dark" ? import_theme.DarkTheme : import_theme.DefaultTheme,
          documentTitle: {
            enabled: false
          },
          ...navigationContainerProps,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_serverLocationContext.ServerLocationContext.Provider, {
            value: location,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ScrollBehavior.ScrollBehavior, {}),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_RootErrorBoundary.RootErrorBoundary, {
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, {})
                })
              ]
            })
          })
        }),
        typeof window !== "undefined" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_PreloadLinks.PreloadLinks, {}, "preload-links")
      ]
    })
  });
  if (props.flags) {
    contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_FlagsContext.FlagsContext.Provider, {
      value: props.flags,
      children: contents
    });
  }
  if (!process.env.ONE_DISABLE_STRICT_MODE) {
    contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.StrictMode, {
      children: contents
    });
  }
  if (isClient) {
    var _globalThis_SERVER_CONTEXT_KEY;
    var serverMode = (_globalThis_SERVER_CONTEXT_KEY = globalThis[import_constants.SERVER_CONTEXT_KEY]) === null || _globalThis_SERVER_CONTEXT_KEY === void 0 ? void 0 : _globalThis_SERVER_CONTEXT_KEY.mode;
    if (serverMode === "spa") {
      var [show, setShow] = (0, import_react.useState)(false);
      (0, import_react.useLayoutEffect)(function() {
        setShow(true);
      }, []);
      return show ? contents : null;
    }
    if (serverMode === "spa-shell") {
      var [isSpaShell, setIsSpaShell] = (0, import_react.useState)(true);
      (0, import_react.useLayoutEffect)(function() {
        setIsSpaShell(false);
      }, []);
      (0, import_react.useLayoutEffect)(function() {
        if (!isSpaShell) {
          var initialPath = window.location.pathname + window.location.search;
          requestAnimationFrame(function() {
            var _store_navigationRef;
            if (window.location.pathname + window.location.search !== initialPath) return;
            var nav = (_store_navigationRef = store.navigationRef) === null || _store_navigationRef === void 0 ? void 0 : _store_navigationRef.current;
            if (!nav) return;
            var linking2 = (0, import_linkingConfig.getResolvedLinking)();
            if (linking2 === null || linking2 === void 0 ? void 0 : linking2.getStateFromPath) {
              var freshState = linking2.getStateFromPath(initialPath, linking2.config);
              if (freshState) {
                nav.resetRoot(freshState);
              }
            }
          });
        }
      }, [
        isSpaShell
      ]);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_SpaShellContext.SpaShellContext.Provider, {
        value: isSpaShell,
        children: contents
      });
    }
    return contents;
  }
  if (props.mode === "spa-shell") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_SpaShellContext.SpaShellContext.Provider, {
      value: true,
      children: contents
    });
  }
  return contents;
}
var onUnhandledAction;
if (process.env.NODE_ENV !== "production") {
  onUnhandledAction = function(action) {
    var payload = action.payload;
    var message = `The action '${action.type}'${payload ? ` with payload ${JSON.stringify(action.payload)}` : ""} was not handled by any navigator.`;
    switch (action.type) {
      case "NAVIGATE":
      case "PUSH":
      case "REPLACE":
      case "JUMP_TO":
        if (payload === null || payload === void 0 ? void 0 : payload.name) {
          message += `

Do you have a route named '${payload.name}'?`;
        } else {
          message += `

You need to pass the name of the screen to navigate to. This may be a bug.`;
        }
        break;
      case "GO_BACK":
      case "POP":
      case "POP_TO_TOP":
        message += `

Is there any screen to go back to?`;
        break;
      case "OPEN_DRAWER":
      case "CLOSE_DRAWER":
      case "TOGGLE_DRAWER":
        message += `

Is your screen inside a Drawer navigator?`;
        break;
    }
    message += `

This is a development-only warning and won't be shown in production.`;
    if (process.env.NODE_ENV === "test") {
      throw new Error(message);
    }
    console.error(message);
  };
} else {
  onUnhandledAction = function() {
  };
}
//# sourceMappingURL=Root.js.map
